export default __webpack_public_path__ + "fonts/de57fbdf95463456ea59b8e8604df63a.svg";